// /* eslint-disable no-console */
// /* eslint-disable no-empty */
// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-unused-vars */
// import React, { useState, useEffect, useRef } from 'react';
// import SignatureCanvas from 'react-signature-canvas';
// import SignaturePad from 'react-signature-canvas';
// import { v4 as uuidv4 } from 'uuid';
// import metaMask from '../../assets/images/nft/newrecord.png';
// import Swal from 'sweetalert2';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

// import { Link } from 'react-router-dom';
// import {
//   Tooltip,
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
//   Container,
//   Form,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   CardHeader,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
//   Modal,
//   ModalFooter,
//   ModalHeader,
//   ModalBody,
//   Label,
//   Button,
//   Input,
// } from 'reactstrap';
// import { Editor, EditorProvider } from 'react-simple-wysiwyg';
// import { Alert, UncontrolledAlert } from 'reactstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import ReactQuill from 'react-quill';
// import { incoTermTable, deliveryUnit } from '../../common/data';
// import ActionMenu from './ActionMenu';
// import FileUploadSection from './component/FileUploadSection';
// import axios from 'axios';
// import { api, download, web } from '../../config';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Select from 'react-select';
// import ModeDeliveryTableFragment from './component/ModelDeliveryFragment';

// import {
//   formatForShortDateAPI,
//   formatForAPI,
// } from '../../utils/dateformatpickr';

// import {
//   PricingPeriodData,
//   IncotermPortTypeData,
// } from '../../constants/masterData';

// import {
//   convertToInputDateFormat,
//   convertToDisplayDateFormat,
//   formatDateToDDMMYYYY,
//   convertDisplayddMMyyyy,
//   formatDateToddmmyyhhmm,
// } from '../../utils/dateformatter';
// import Flatpickr from 'react-flatpickr';
// import 'flatpickr/dist/themes/light.css';
// import { Indonesian } from 'flatpickr/dist/l10n/id';
// import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
// import IncotermTableParcelFragment from './component/IncotermTableParcelFragment';

// const HpsRequestTab = ({
//   ids,
//   form,
//   setForm,
//   errors,
//   error,
//   token,
//   setIsLoading,
//   isLoading,
//   qtyDeliveryData,
//   handleSaveHPSrequest,
// }) => {
//   const [uploadDocument, setUploadDocument] = useState({ items: [] });
//   const [listUserIdaman, setlistUserIdaman] = useState({ items: [] });
//   const [Overview, setOverview] = useState({});
//   const { user } = useSelector(state => state.Login);
//   const navigate = useNavigate();

//   const [readonly, setReadOnly] = useState(false);
//   const [formFileUpload, setFormFileUpload] = useState({
//     ProcurementId: ids,
//     DocumentUploadId: '',
//     fileAttachment: '',
//   });
//   const [startDate, setStartDate] = useState(null); // from
//   const [endDate, setEndDate] = useState(null); // to
//   const [termType, setTermType] = useState('TERM');
//   const handleNumberChange = fieldName => e => {
//     const input = e.target.value;
//     if (isNumericOnly(input)) {
//       setFormData(prev => ({
//         ...prev,
//         [fieldName]: input === '' ? '0' : input,
//       }));
//     }
//   };

//   useEffect(() => {
//     if (ids) {
//       fetchDocumentUpload(ids);
//       setReadOnly(form?.hpsStatus == 1);
//     }
//   }, [ids, form?.hpsStatus]);

//   const fetchDocumentUpload = async ids => {
//     try {
//       const response = await fetch(
//         `${api.API_URL}/hps/getall-hps-doc-uploaded?ProcurementId=${ids}`,
//         {
//           params: { ProcurementId: ids },
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
//       const items = result.data.items.map(item => ({
//         id: item.id ?? null,
//         documentName: item.documentUpload.documentName ?? null,
//         documentUploadId: item.documentUploadId ?? null,
//         actualUrl: item.link ?? null,
//       }));
//       setUploadDocument({ items });
//     } catch (error) {
//       console.error('Error fetching data from Invoice API:', error);
//     }
//   };

//   const handleTextChange = field => event => {
//     setOverview({
//       ...Overview,
//       [field]: event.target.value,
//     });
//   };

//   const toggledeletemodal = () => {
//     setDeleteModal(!deletemodal);
//   };

//   const togglemodal = () => {
//     setModal(!modal);
//   };

//   const sigCanvas = useRef(null);

//   const [modal_togFirst, setmodal_togFirst] = useState(false);
//   function tog_togFirst() {
//     setmodal_togFirst(!modal_togFirst);
//   }
//   const [modal_togSecond, setmodal_togSecond] = useState(false);
//   function tog_togSecond() {
//     setmodal_togSecond(!modal_togSecond);
//   }

//   const [name, setName] = useState('');
//   const [message, setMessage] = useState('');

//   const clear = () => {
//     sigCanvas.current.clear();
//     setMessage('');
//   };

//   const handleConfirmDelFileUpload = (id = null) =>
//     Swal.fire({
//       title: `Are You sure want to Delete this Record?`,
//       text: 'Deleted Data cannot be Recovered!!',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes, Delete!',
//       cancelButtonText: 'Cancel',
//     }).then(result => {
//       if (result.isConfirmed) {
//         return handleDelFileUpload(id);
//       }
//     });

//   const handleDelFileUpload = async id => {
//     try {
//       setIsLoading(true);
//       const response = await axios.delete(
//         `${api.API_URL}/hps/delete-document/${id}`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       toast.success(`Data has been deleted`);
//     } catch (error) {
//       toast.error(`Failed to delete data: ${error.message}`);
//       setError(error.message);
//     } finally {
//       setIsLoading(false);
//       fetchDocumentUpload(ids);
//     }
//   };

//   useEffect(() => {
//     fetchlistUserIdaman();
//   }, []);

//   const fetchlistUserIdaman = async () => {
//     try {
//       const response = await fetch(
//         `${api.API_URL}/usermanagement/get-user-idaman?PageNumber=1&PageSize=20000`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
//       const items = result.data.items.map(item => ({
//         value: item.id,
//         label: item.displayName,
//       }));
//       setlistUserIdaman({ items });
//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//     }
//   };

//   const handleSelectChange = (e, field) => {
//     const value = e ? e.value : '';
//     const newData = {
//       ...form,
//       [field]: value,
//     };
//     setForm(newData);
//   };

//   const handleFormTextChange = e => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleFormDateChange = e => {
//     const { name, value } = e.target;
//     setForm({
//       ...form,
//       [name]: convertToDisplayDateFormat(value),
//     });
//   };

//   const handleDateChange = (selectedDates, dateStr, instance, field) => {
//     setForm({
//       ...form,
//       [field]: formatForShortDateAPI(selectedDates[0]), // Simpan dalam format ISO untuk POST
//     });
//   };

//   const handleAddOverviewSubmit = async ids => {
//     try {
//       const trimmedCanvas = sigCanvas.current.getCanvas();
//       const dataURL = trimmedCanvas.toDataURL('image/png');
//       const blob = await (await fetch(dataURL)).blob();
//       const fileName = `signature.png`;
//       if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
//         toast.error('Silakan tanda tangan terlebih dahulu');
//         return;
//       }
//       const newOverview = {
//         FullName: user.username,
//         Position: '',
//         Division: '',
//         Signature: '', // default sebelum tanda tangan
//       };
//       // Update state
//       setOverview(newOverview);
//       const formData = new FormData();
//       formData.append('ProcurementId', form.id);
//       formData.append('FullName', newOverview.FullName || '');
//       formData.append('Position', newOverview.Position || '');
//       formData.append('Division', newOverview.Division || '');
//       formData.append('Signature', newOverview.Signature || '');
//       formData.append('FileSignatureSpecimen', blob, fileName);
//       const response = await axios.post(
//         `${api.API_URL}/hps/digital-signature`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       Swal.fire({
//         title: 'Submission Successful',
//         text: 'TheRequest HPS from has been successfully submitted for final validation. You will be notified once the process is complete',
//         icon: 'success',
//       });
//       navigate(`/apps-requesthps/view`);
//       setmodal_togSecond(false);
//     } catch (err) {
//       console.error('handleAddOverviewSubmit error:', err);
//     } finally {
//       setIsLoading && setIsLoading(false);
//     }
//   };

//   const modalWidth = '415px';

//   const handleDirectOpenNewTab = url => {
//     const link = document.createElement('a');
//     link.href = url;
//     link.target = '_blank'; // buka tab baru
//     link.rel = 'noopener noreferrer'; // best practice
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <React.Fragment>
//       <Row>
//         <div>
//           <Row>
//             <Col sm={12}>
//               <div color='dark' className='d-flex align-items-center mb-2  '>
//                 <div className='flex-grow-1'>
//                   <h5 className='mb-1'>Request HPS</h5>
//                   <p className='text-muted mb-2 fs-12 '>
//                     Bisa jadi Kalimat tambahan untuk membantu section mengenai
//                     apa ini
//                   </p>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   borderTopColor: '#b0b8b2',
//                   borderTopWidth: '1px',
//                   borderTopStyle: 'solid',
//                 }}
//               ></div>
//             </Col>
//           </Row>
//         </div>

//         <div>
//           <Row>
//             <Col sm={3}>
//               <div className='mt-2'>
//                 <Label htmlFor='hpsRequestNumber' className='form-label'>
//                   HPS Request Number
//                 </Label>
//                 <Input
//                   type='text'
//                   className='form-control'
//                   id='hpsRequestNumber'
//                   name='hpsRequestNumber'
//                   disabled={true}
//                   value={form.hpsRequestNumber}
//                 />
//               </div>
//             </Col>
//             <Col sm={3}>
//               <div className='mt-2'>
//                 <Label htmlFor='hpsRequestDate' className='form-label'>
//                   Request Dated
//                 </Label>

//                 <Input
//                   type='date'
//                   id='hpsRequestDate'
//                   name='hpsRequestDate'
//                   value={convertToInputDateFormat(form.hpsRequestDate)}
//                   className={
//                     form.hpsStatusCompleted
//                       ? 'form-control bg-light border-1'
//                       : 'form-control '
//                   }
//                   onChange={e => {
//                     handleFormDateChange(e);
//                   }}
//                   disabled={form.hpsStatusCompleted ? true : false}
//                 />
//               </div>
//             </Col>
//           </Row>

//           <Row>
//             <Col sm={3}>
//               <div className='mb-2 mt-2'>
//                 <Label htmlFor='userIdamanId' className='form-label'>
//                   Request Name
//                 </Label>
//                 <Select
//                   name='userIdamanId'
//                   id='userIdamanId'
//                   options={listUserIdaman.items}
//                   placeholder='Please Select'
//                   value={
//                     listUserIdaman.items?.find(
//                       obj => obj.value === form.userIdamanId
//                     ) || null
//                   }
//                   onChange={e => {
//                     handleSelectChange(e, 'userIdamanId');
//                   }}
//                   isDisabled={form.hpsStatusCompleted}
//                 />
//               </div>
//             </Col>

//             <Col sm={3}>
//               <div className='mb-2 mt-2'>
//                 <Label htmlFor='userIdDept' className='form-label'>
//                   Department / Division
//                 </Label>
//                 <Input
//                   type='text'
//                   className='form-control'
//                   id='userIdDept'
//                   name='userIdDept'
//                   disabled={true}
//                 />
//               </div>
//             </Col>
//           </Row>
//         </div>

//         <div>
//           <Row>
//             <Col sm={12}>
//               <div
//                 style={{
//                   borderTopColor: '#b0b8b2',
//                   borderTopWidth: '1px',
//                   borderTopStyle: 'solid',
//                 }}
//               ></div>
//               <div className='flex-grow-1'>
//                 <Label
//                   for='choices-payment-type'
//                   className='form-label  text-uppercase fw-semibold'
//                 >
//                   Input Document
//                 </Label>
//                 <p className='text-muted mb-2 fs-12 '>
//                   Bisa jadi Kalimat tambahan untuk membantu section mengenai apa
//                   ini
//                 </p>
//               </div>
//             </Col>

//             <Row>
//               <Col sm={3}>
//                 <div className='mb-2'>
//                   <Label htmlFor='invoicingQuantityId' className='form-label '>
//                     Nomor Nota Dinas Permintaan (P-Office)
//                   </Label>
//                   <Input
//                     type='text'
//                     className='form-control '
//                     id='noNotaDinas'
//                     name='noNotaDinas'
//                     value={form.noNotaDinas || ''}
//                     placeholder='Number Generated by P-Office'
//                     onChange={e => {
//                       handleFormTextChange(e);
//                     }}
//                     disabled={form.hpsStatusCompleted ? true : false}
//                   />
//                 </div>
//               </Col>

//               <Col sm={6}>
//                 <p className=' mb-2 fs-12 '>
//                   Select Category and Documents to upload
//                 </p>
//                 <div className='d-flex'>
//                   <table className='table table-hover table-centered align-middle table-nowrap mb-2'>
//                     <thead className='text-muted table-light'>
//                       <tr>
//                         <th scope='col' width='80%'>
//                           Category FIle
//                         </th>
//                         <th scope='col' width='20%'>
//                           {''}
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {uploadDocument?.items?.length > 0 ? (
//                         uploadDocument.items.map((data, index) => (
//                           <tr key={`${data.id}-${index}`}>
//                             <td>
//                               <p className='mb-2 mt-2'>{data.documentName}</p>
//                             </td>
//                             <td>
//                               <ul className='list-inline hstack gap-2 mb-0'>
//                                 <button
//                                   type='button'
//                                   className='btn btn-outline-primary btn-sm'
//                                   onClick={() =>
//                                     handleDirectOpenNewTab(data.actualUrl)
//                                   }
//                                 >
//                                   View
//                                 </button>
//                                 {readonly && (
//                                   <button
//                                     type='button'
//                                     className='btn btn-outline-danger btn-sm'
//                                     onClick={() =>
//                                       handleConfirmDelFileUpload(data.id)
//                                     }
//                                   >
//                                     Delete
//                                   </button>
//                                 )}
//                               </ul>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan='3' className='text-center text-muted'>
//                             No documents available
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </Col>
//               {form.hpsStatusCompleted === false && (
//                 <Col sm={3}>
//                   <FileUploadSection
//                     ids={ids}
//                     fetchDocumentUpload={() => fetchDocumentUpload(ids)}
//                     formFileUpload={formFileUpload}
//                     setFormFileUpload={setFormFileUpload}
//                     uploadDocument={uploadDocument}
//                     readonly={readonly}
//                   />
//                 </Col>
//               )}
//             </Row>
//           </Row>
//         </div>

//         <div className='mt-3'>
//           <Row>
//             <Col sm={12}>
//               <div
//                 style={{
//                   borderTopColor: '#b0b8b2',
//                   borderTopWidth: '1px',
//                   borderTopStyle: 'solid',
//                 }}
//               ></div>
//               <div className='flex-grow-1'>
//                 <Label
//                   for='choices-payment-type'
//                   className='form-label  text-uppercase fw-semibold'
//                 >
//                   Parcel
//                 </Label>

//                 <p className='text-muted mb-2 fs-12 '>
//                   Bisa jadi Kalimat tambahan untuk membantu section mengenai apa
//                   ini
//                 </p>
//               </div>
//             </Col>

//             <Col xl={12}>
//               <div className='mb-1'>
//                 {isLoading ? (
//                   <Col lg={12} className='text-center'>
//                     <div className='text-center'>
//                       <div
//                         className='spinner-border text-primary'
//                         role='status'
//                       >
//                         <span className='visually-hidden'>Loading...</span>
//                       </div>
//                     </div>
//                   </Col>
//                 ) : error ? (
//                   <Col lg={12} className='text-center'>
//                     <div className='text-center'>
//                       <div className='alert alert-danger'>{error}</div>
//                     </div>
//                   </Col>
//                 ) : (
//                   <>
//                     {qtyDeliveryData.items.length > 0 ? (
//                       qtyDeliveryData.items.map((data, index) => (
//                         <Col sm={12} key={`${data.id}-${index}`}>
//                           <Col xxl={12}>
//                             <TabPane tabId={`${data.id}2`} id='product'>
//                               <Col sm={12}>
//                                 <Row>
//                                   <Col sm={5}>
//                                     <Row>
//                                       <Col sm={6}>
//                                         <div className='mb-2'>
//                                           <Label
//                                             for='product-name-1'
//                                             className='form-label fw-semibold'
//                                           >
//                                             Delivery Unit
//                                           </Label>
//                                           <Input
//                                             type='text'
//                                             className='form-control bg-light border-1'
//                                             id='deliveryUnitRO'
//                                             readOnly
//                                             value={data.deliveryUnit || ''}
//                                           />
//                                         </div>
//                                       </Col>

//                                       <Col sm={6}>
//                                         <div className='mb-2'>
//                                           <Label
//                                             for='product-name-2'
//                                             className='form-label '
//                                           >
//                                             Pricing Period
//                                           </Label>
//                                           <Input
//                                             type='text'
//                                             className='form-control bg-light border-1'
//                                             id='deliveryUnitRO'
//                                             value={
//                                               PricingPeriodData[0].options.find(
//                                                 option =>
//                                                   option.value ===
//                                                   data.pricingPeriod
//                                               )?.label || ''
//                                             }
//                                             readOnly
//                                           />
//                                         </div>
//                                       </Col>

//                                       <Col sm={6}>
//                                         <div className='mb-2'>
//                                           <Label
//                                             for='product-name-3'
//                                             className='form-label '
//                                           >
//                                             Index Price Reference
//                                           </Label>
//                                           <Input
//                                             type='text'
//                                             className='form-control bg-light border-1 '
//                                             id='indexPricenameRO'
//                                             readOnly
//                                             value={data.indexPricename || ''}
//                                           />
//                                         </div>
//                                       </Col>

//                                       <Col sm={6}>
//                                         <div className='mb-2'>
//                                           <Label
//                                             for='product-name-3'
//                                             className='form-label '
//                                           >
//                                             Other Index Price
//                                           </Label>
//                                           <Input
//                                             type='text'
//                                             className='form-control bg-light border-1 '
//                                             id='otherIndexPricenameRO'
//                                             readOnly
//                                             value={
//                                               data.otherIndexPricename || ''
//                                             }
//                                           />
//                                         </div>
//                                       </Col>
//                                       {data.isCorrelationBetweenTwoIndex && (
//                                         <Col sm={12}>
//                                           <div className='mb-2'>
//                                             <Label
//                                               className='form-check-label'
//                                               for='inlineCheckbox8'
//                                             >
//                                               Correlation between two index
//                                               whicever to lower
//                                             </Label>
//                                           </div>
//                                         </Col>
//                                       )}
//                                       {data.pricingPeriod === 1 && (
//                                         <Col sm={4}>
//                                           <div className='mb-2'>
//                                             <Label
//                                               for='product-name-3'
//                                               className='form-label '
//                                             >
//                                               Publish Index Period :
//                                             </Label>
//                                             <Input
//                                               type='text'
//                                               className='form-control bg-light border-1'
//                                               id='startDatePublishIndexRO'
//                                               readOnly
//                                               value={formatDateToDDMMYYYY(
//                                                 data.startDatePublishIndex
//                                               )}
//                                             />
//                                           </div>
//                                         </Col>
//                                       )}
//                                       {data.pricingPeriod === 1 && (
//                                         <Col sm={4}>
//                                           <div className='mb-2'>
//                                             <Label
//                                               for='product-name-3'
//                                               className='form-label '
//                                             ></Label>
//                                             <Input
//                                               type='text'
//                                               className='form-control bg-light border-1  '
//                                               id='endDatePublishIndex'
//                                               readOnly
//                                               value={formatDateToDDMMYYYY(
//                                                 data.endDatePublishIndex
//                                               )}
//                                             />
//                                           </div>
//                                         </Col>
//                                       )}
//                                       {data.pricingPeriod === 2 && (
//                                         <Col sm={4}>
//                                           <div className='mb-2'>
//                                             <Label
//                                               for='product-name-3'
//                                               className='form-label '
//                                             >
//                                               Schema B/L Date
//                                             </Label>
//                                             <Input
//                                               type='text'
//                                               className='form-control bg-light border-1 '
//                                               id='totalamountInput'
//                                               readOnly
//                                               value={data.schemaBL || ''}
//                                             />
//                                           </div>
//                                         </Col>
//                                       )}
//                                     </Row>
//                                   </Col>

//                                   <Col sm={7}>
//                                     <Label
//                                       for='product-name-3'
//                                       className='form-label '
//                                     >
//                                       Notes for Pricing
//                                     </Label>
//                                     <div className='snow-editor '>
//                                       <EditorProvider>
//                                         <Editor
//                                           id='notesForPricingRO'
//                                           name='notesForPricingRO'
//                                           className='form-control bg-light border-0'
//                                           value={data.notesForPricing || ''}
//                                           readOnly
//                                           style={{
//                                             height: '200px',
//                                             overflowY: 'auto',
//                                           }}
//                                         ></Editor>
//                                       </EditorProvider>
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </Col>

//                               {/* <IncotermTableParcelFragment
//                                   incoTermTable={incoTermTable}
//                                   dataid={data.id}
//                                   token={token}
//                                 /> */}

//                               <ModeDeliveryTableFragment
//                                 procurementId={form.id}
//                                 quantityDeliveryTermId={data.id}
//                                 token={token}
//                               />

//                               <div
//                                 className='mt-2 mb-2'
//                                 style={{
//                                   borderTopColor: '#b0b8b2',
//                                   borderTopWidth: '1px',
//                                   borderTopStyle: 'solid',
//                                 }}
//                               ></div>
//                             </TabPane>
//                           </Col>
//                         </Col>
//                       ))
//                     ) : (
//                       <Col lg={12} className='text-center'>
//                         <h5 className='fs-15'>
//                           <i className='ri-database-2-line me-2'></i>
//                           No data available
//                         </h5>
//                       </Col>
//                     )}
//                   </>
//                 )}
//               </div>
//             </Col>
//           </Row>
//         </div>

//         <div className='hstack flex-wrap gap-2 justify-content-end d-print-none mt-1'>
//           {readonly && (
//             <Button
//               type='button'
//               className='btn btn-success btn-label right me-1'
//               onClick={() => {
//                 handleSaveHPSrequest({ ids });
//               }}
//             >
//               <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>
//               Save as Draft
//             </Button>
//           )}
//           {readonly && (
//             <Button
//               type='button'
//               className='btn btn-primary btn-label right me-1'
//               onClick={() => tog_togFirst()}
//             >
//               <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>
//               Submit HPS Request
//             </Button>
//           )}
//         </div>
//       </Row>

//       <Modal
//         isOpen={modal_togFirst}
//         toggle={() => {
//           tog_togFirst();
//         }}
//         id='firstmodal'
//         centered
//       >
//         <ModalHeader
//           toggle={() => {
//             setmodal_togFirst(false);
//           }}
//         ></ModalHeader>
//         <ModalBody className='text-center p-5'>
//           <div className='mt-2 pt-2'>
//             <Row className='justify-content-center mb-1'>
//               <Col lg={12} className='text-center'>
//                 <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
//                 <h5>Confirm Final Submission</h5>
//                 <p className='text-muted pb-1'>
//                   Are you sure you want to submit this HPS Request process for
//                   final validation? This action cannot be undone
//                 </p>
//               </Col>
//             </Row>
//             {/*
//             <Col lg={12}>
//               <div className="mb-2 bor border-top  border-top-dashed "></div>
//             </Col> */}

//             {/* <h4>Confirm Final Submission</h4>
//             <p className="text-muted">
//               {" "}
//               Are you sure you want to submit this planning & procurement
//               process for final validation? This action cannot be undone
//             </p> */}
//             <Button
//               className='btn btn-primary'
//               onClick={() => {
//                 tog_togSecond();
//                 tog_togFirst(false);
//               }}
//             >
//               Yes, Next
//             </Button>
//           </div>
//         </ModalBody>
//       </Modal>

//       <Modal
//         isOpen={modal_togSecond}
//         toggle={() => {
//           setmodal_togSecond();
//         }}
//         id='secondmodal'
//         centered
//         style={{ maxWidth: modalWidth }}
//         className='custom-modal-width'
//       >
//         <ModalHeader
//           toggle={() => {
//             setmodal_togSecond(false);
//           }}
//         ></ModalHeader>
//         <ModalBody>
//           <Col sm={12}>
//             <Row>
//               <Row className='justify-content-center mb-1'>
//                 <Col lg={12} className='text-center'>
//                   <img
//                     src={metaMask}
//                     alt=''
//                     height='65'
//                     className='mb-3 pb-2'
//                   />
//                   <h5>Digital Signature Confirmation</h5>
//                 </Col>
//               </Row>

//               <Col lg={12}>
//                 <div className='mb-2 bor border-top  border-top-dashed '></div>
//               </Col>

//               <Col sm={12}>
//                 <div className='mb-2 mt-2'>
//                   <Label for='FullName' className='form-label fw-semibold '>
//                     Full Name:
//                   </Label>
//                   <Input
//                     type='text'
//                     id='FullName'
//                     name='FullName'
//                     value={user.username}
//                     className='form-control'
//                     onChange={e => {
//                       handleTextChange(e);
//                     }}
//                     disabled={true}
//                   />
//                 </div>
//               </Col>
//               <Col sm={12}>
//                 <div className='mb-2'>
//                   <Label for='Position' className='form-label fw-semibold '>
//                     Position:
//                   </Label>
//                   <Input
//                     type='text'
//                     id='Position'
//                     name='Position'
//                     value={''}
//                     className='form-control'
//                     onChange={e => {
//                       handleTextChange(e);
//                     }}
//                     disabled={true}
//                   />
//                 </div>
//               </Col>
//               <Col sm={12}>
//                 <div className='mb-2'>
//                   <Label for='Division' className='form-label fw-semibold '>
//                     Division:
//                   </Label>
//                   <Input
//                     type='text'
//                     id='Division'
//                     name='Division'
//                     value={''}
//                     className='form-control'
//                     onChange={e => {
//                       handleTextChange(e);
//                     }}
//                     disabled={true}
//                   />
//                 </div>
//               </Col>

//               <Col sm={12}>
//                 <div className='mb-2'>
//                   <Label for='deliveryUnit' className='form-label fw-semibold '>
//                     Signature:
//                   </Label>
//                 </div>
//               </Col>
//               <Col sm={12}>
//                 <div style={{ maxWidth: '100%' }}>
//                   <SignatureCanvas
//                     ref={sigCanvas}
//                     penColor='black'
//                     canvasProps={{
//                       width: 370,
//                       height: 200,
//                       className: 'sigCanvas',
//                       style: { border: '1px solid #5555' },
//                     }}
//                   />
//                 </div>
//               </Col>
//             </Row>
//           </Col>
//         </ModalBody>

//         <ModalFooter className='text-center '>
//           <Button
//             type='button'
//             className='btn btn-primary btn-label right  nexttab'
//             onClick={() => {
//               setmodal_togSecond(false);
//             }}
//           >
//             <i className='ri-logout-box-r-line label-icon align-middle fs-16 ms-2'></i>
//             Cancel
//           </Button>

//           <Button
//             type='button'
//             className='btn btn-primary btn-label right  nexttab'
//             onClick={() => {
//               handleAddOverviewSubmit({ ids });
//             }}
//           >
//             <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>
//             Confirm & Submit
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </React.Fragment>
//   );
// };

// export default HpsRequestTab;

/* eslint-disable no-console */
/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import SignaturePad from 'react-signature-canvas';
import { v4 as uuidv4 } from 'uuid';
import metaMask from '../../assets/images/nft/newrecord.png';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import {
  Tooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Form,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Button,
  Input,
} from 'reactstrap';
import { Editor, EditorProvider } from 'react-simple-wysiwyg';
import { Alert, UncontrolledAlert } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ReactQuill from 'react-quill';
import { incoTermTable, deliveryUnit } from '../../common/data';
import ActionMenu from './ActionMenu';
import FileUploadSection from './component/FileUploadSection';
import axios from 'axios';
import { api, download, web } from '../../config';
import notify from '../../utils/notify';
import { confirmDelete } from '../../utils/confirm';
import Select from 'react-select';
import ModeDeliveryTableFragment from './component/ModelDeliveryFragment';

import {
  formatForShortDateAPI,
  formatForAPI,
} from '../../utils/dateformatpickr';

import {
  PricingPeriodData,
  IncotermPortTypeData,
} from '../../constants/masterData';

import {
  convertToInputDateFormat,
  convertToDisplayDateFormat,
  formatDateToDDMMYYYY,
  convertDisplayddMMyyyy,
  formatDateToddmmyyhhmm,
} from '../../utils/dateformatter';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/light.css';
import { Indonesian } from 'flatpickr/dist/l10n/id';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import IncotermTableParcelFragment from './component/IncotermTableParcelFragment';
import ActionButton from '../../Components/Common/ActionButton';
import { SkeletonCard, SkeletonTable } from '../../Components/Common/Skeleton';

const HpsRequestTab = ({
  ids,
  form,
  setForm,
  errors,
  error,
  setError,
  token,
  setIsLoading,
  isLoading,
  qtyDeliveryData,
  handleSaveHPSrequest,
}) => {
  const [uploadDocument, setUploadDocument] = useState({ items: [] });
  const [docsLoaded, setDocsLoaded] = useState(false);
  const [listUserIdaman, setlistUserIdaman] = useState({ items: [] });
  const [Overview, setOverview] = useState({});
  const { user } = useSelector(state => state.Login);
  const navigate = useNavigate();

  const [readonly, setReadOnly] = useState(false);
  const [formFileUpload, setFormFileUpload] = useState({
    ProcurementId: ids,
    DocumentUploadId: '',
    fileAttachment: '',
  });
  const [startDate, setStartDate] = useState(null); // from
  const [endDate, setEndDate] = useState(null); // to
  const [termType, setTermType] = useState('TERM');

  // State untuk optimasi loading data
  const [userOptions, setUserOptions] = useState([]);
  const [userOptionsCache, setUserOptionsCache] = useState(new Map());
  const [userSearchCache, setUserSearchCache] = useState(new Map());
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  // Ref untuk tracking request yang sedang berjalan
  const requestRef = useRef(null);

  useEffect(() => {
    if (ids) {
      fetchDocumentUpload(ids);
      setReadOnly(form?.hpsStatus == 1);
    }
  }, [ids, form?.hpsStatus]);

  const fetchDocumentUpload = async ids => {
    try {
      const response = await fetch(
        `${api.API_URL}/hps/getall-hps-doc-uploaded?ProcurementId=${ids}`,
        {
          params: { ProcurementId: ids },
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = (result.data?.items || []).map(item => ({
        id: item.id ?? null,
        documentName: item.documentUpload?.documentName ?? null,
        documentUploadId: item.documentUploadId ?? null,
        actualUrl: item.link ?? null,
      }));
      setUploadDocument({ items });
    } catch (error) {
      console.error('Error fetching data from Invoice API:', error);
    } finally {
      setDocsLoaded(true);
    }
  };

  const handleTextChange = field => event => {
    setOverview({
      ...Overview,
      [field]: event.target.value,
    });
  };

  const sigCanvas = useRef(null);

  const [modal_togFirst, setmodal_togFirst] = useState(false);
  function tog_togFirst() {
    setmodal_togFirst(!modal_togFirst);
  }
  const [modal_togSecond, setmodal_togSecond] = useState(false);
  function tog_togSecond() {
    setmodal_togSecond(!modal_togSecond);
  }

  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const clear = () => {
    sigCanvas.current.clear();
    setMessage('');
  };

  const handleConfirmDelFileUpload = async (id = null, subject) => {
    if (!(await confirmDelete('document', subject))) return;
    await handleDelFileUpload(id);
  };

  const handleDelFileUpload = async id => {
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${api.API_URL}/hps/delete-document/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      notify.success('Data deleted successfully.');
    } catch (error) {
      notify.apiError(error, 'delete data');
      setError(error.message);
    } finally {
      setIsLoading(false);
      fetchDocumentUpload(ids);
    }
  };

  // Fungsi untuk memuat data user dengan pagination dan search
  const fetchUsers = useCallback(
    async (query = '', page = 1, append = false) => {
      // Batalkan request sebelumnya jika masih berjalan
      if (requestRef.current) {
        requestRef.current.abort();
      }

      // Buat AbortController baru untuk request ini
      const controller = new AbortController();
      requestRef.current = controller;

      try {
        setIsLoadingUsers(true);

        // Tentukan cache key berdasarkan query
        const cacheKey = query || 'default';

        // Jika query kosong dan kita sudah memiliki data di cache, gunakan cache
        if (!query && userOptionsCache.has(page) && !append) {
          return userOptionsCache.get(page);
        }

        // Jika query tidak kosong dan kita sudah memiliki hasil search di cache, gunakan cache
        if (query && userSearchCache.has(cacheKey) && !append) {
          return userSearchCache.get(cacheKey);
        }

        const response = await fetch(
          `${api.API_URL}/usermanagement/get-user-idaman?PageNumber=${page}&PageSize=100&DisplayName=${query}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
          }
        );

        const result = await response.json();
        const items = result.data.items.map(item => ({
          value: item.id,
          label: item.displayName,
        }));

        // Simpan ke cache yang sesuai
        if (!query) {
          const newCache = new Map(userOptionsCache);
          newCache.set(page, items);
          setUserOptionsCache(newCache);
        } else {
          const newCache = new Map(userSearchCache);
          newCache.set(cacheKey, items);
          setUserSearchCache(newCache);
        }

        // Periksa apakah masih ada data lagi
        setHasMore(items.length === 100);

        return items;
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching users:', error);
        }
        return [];
      } finally {
        setIsLoadingUsers(false);
      }
    },
    [token, userOptionsCache, userSearchCache]
  );

  // Fungsi untuk memuat data awal
  useEffect(() => {
    // Jika form memiliki userIdamanId, muat data user tersebut
    if (form.userIdamanId) {
      // Cari di cache terlebih dahulu
      let foundUser = null;
      for (const [page, options] of userOptionsCache.entries()) {
        const user = options.find(option => option.value === form.userIdamanId);
        if (user) {
          foundUser = user;
          break;
        }
      }

      if (foundUser) {
        setSelectedUser(foundUser);
      } else {
        // Jika tidak ada di cache, muat data user tersebut
        fetchUsers('', 1).then(items => {
          const user = items.find(option => option.value === form.userIdamanId);
          if (user) {
            setSelectedUser(user);
          }
        });
      }
    }

    // Muat data awal untuk dropdown
    fetchUsers().then(items => {
      setUserOptions(items);
    });
  }, [form.userIdamanId, fetchUsers, userOptionsCache]);

  // Fungsi untuk handle input change pada Select
  const handleInputChange = useCallback(
    inputValue => {
      // Jika input kosong, reset ke data default
      if (!inputValue) {
        setSearchQuery('');
        setCurrentPage(1);
        fetchUsers().then(items => {
          setUserOptions(items);
        });
        return;
      }

      // Jika input berubah, muat data baru
      if (inputValue !== searchQuery) {
        setSearchQuery(inputValue);
        setCurrentPage(1);
        fetchUsers(inputValue).then(items => {
          setUserOptions(items);
        });
      }
    },
    [searchQuery, fetchUsers]
  );

  // Fungsi untuk handle scroll ke bawah pada menu dropdown
  const handleMenuScrollToBottom = useCallback(() => {
    if (!hasMore || isLoadingUsers) return;

    const nextPage = currentPage + 1;
    fetchUsers(searchQuery, nextPage, true).then(newItems => {
      setUserOptions(prev => [...prev, ...newItems]);
      setCurrentPage(nextPage);
    });
  }, [currentPage, hasMore, isLoadingUsers, searchQuery, fetchUsers]);

  const handleSelectChange = (e, field) => {
    const value = e ? e.value : '';
    const newData = {
      ...form,
      [field]: value,
    };
    setForm(newData);
    setSelectedUser(e);
  };

  const handleFormTextChange = e => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFormDateChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: convertToDisplayDateFormat(value),
    });
  };

  const handleDateChange = (selectedDates, dateStr, instance, field) => {
    setForm({
      ...form,
      [field]: formatForShortDateAPI(selectedDates[0]), // Simpan dalam format ISO untuk POST
    });
  };

  const handleAddOverviewSubmit = async ids => {
    try {
      const trimmedCanvas = sigCanvas.current.getCanvas();
      const dataURL = trimmedCanvas.toDataURL('image/png');
      const blob = await (await fetch(dataURL)).blob();
      const fileName = `signature.png`;
      if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
        notify.warning('Please sign first.');
        return;
      }
      const newOverview = {
        FullName: user.username,
        Position: '',
        Division: '',
        Signature: '', // default sebelum tanda tangan
      };
      // Update state
      setOverview(newOverview);
      const formData = new FormData();
      formData.append('ProcurementId', form.id);
      //formData.append('FullName', newOverview.FullName || '');
      //formData.append('Position', newOverview.Position || '');
      //formData.append('Division', newOverview.Division || '');
      //formData.append('Signature', newOverview.Signature || '');
      formData.append('FileSignatureSpecimen', blob, fileName);
      const response = await axios.post(
        `${api.API_URL}/hps/digital-signature`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        title: 'Submission Successful',
        text: 'TheRequest HPS from has been successfully submitted for final validation. You will be notified once the process is complete',
        icon: 'success',
      });
      navigate(`/apps-requesthps/view`);
      setmodal_togSecond(false);
    } catch (err) {
      console.error('handleAddOverviewSubmit error:', err);
    } finally {
      setIsLoading && setIsLoading(false);
    }
  };

  const modalWidth = '415px';

  const handleDirectOpenNewTab = url => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank'; // buka tab baru
    link.rel = 'noopener noreferrer'; // best practice
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Custom style untuk dropdown agar bisa scroll
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided, state) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
  };

  return (
    <React.Fragment>
      <Row>
        <div>
          <Row>
            <Col sm={12}>
              <div color='dark' className='d-flex align-items-center mb-2  '>
                <div className='flex-grow-1'>
                  <h5 className='mb-1'>Request HPS</h5>
                  <p className='text-muted mb-2 fs-12 '>
                    Bisa jadi Kalimat tambahan untuk membantu section mengenai
                    apa ini
                  </p>
                </div>
              </div>
              <div
                style={{
                  borderTopColor: '#b0b8b2',
                  borderTopWidth: '1px',
                  borderTopStyle: 'solid',
                }}
              ></div>
            </Col>
          </Row>
        </div>

        <div>
          <Row>
            <Col sm={6} md={3}>
              <div className='mt-2'>
                <Label htmlFor='hpsRequestNumber' className='form-label'>
                  HPS Request Number
                </Label>
                <Input
                  type='text'
                  className='form-control'
                  id='hpsRequestNumber'
                  name='hpsRequestNumber'
                  disabled={true}
                  value={form.hpsRequestNumber}
                />
              </div>
            </Col>
            <Col sm={6} md={3}>
              <div className='mt-2'>
                <Label htmlFor='hpsRequestDate' className='form-label'>
                  Request Dated
                </Label>

                <Input
                  type='date'
                  id='hpsRequestDate'
                  name='hpsRequestDate'
                  value={convertToInputDateFormat(form.hpsRequestDate)}
                  className={
                    form.hpsStatusCompleted
                      ? 'form-control bg-light border-1'
                      : 'form-control '
                  }
                  onChange={e => {
                    handleFormDateChange(e);
                  }}
                  disabled={form.hpsStatusCompleted ? true : false}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm={6} md={3}>
              <div className='mb-2 mt-2'>
                <Label htmlFor='userIdamanId' className='form-label'>
                  Request Name
                </Label>
                <Select
                  name='userIdamanId'
                  id='userIdamanId'
                  options={userOptions}
                  placeholder='Please Select'
                  value={selectedUser}
                  onChange={e => {
                    handleSelectChange(e, 'userIdamanId');
                  }}
                  onInputChange={handleInputChange}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  isDisabled={form.hpsStatusCompleted}
                  isLoading={isLoadingUsers}
                  styles={customStyles}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? 'No results found' : 'Type to search'
                  }
                />
              </div>
            </Col>

            <Col sm={6} md={3}>
              <div className='mb-2 mt-2'>
                <Label htmlFor='userIdDept' className='form-label'>
                  Department / Division
                </Label>
                <Input
                  type='text'
                  className='form-control'
                  id='userIdDept'
                  name='userIdDept'
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div>
          <Row>
            <Col sm={12}>
              <div
                style={{
                  borderTopColor: '#b0b8b2',
                  borderTopWidth: '1px',
                  borderTopStyle: 'solid',
                }}
              ></div>
              <div className='flex-grow-1'>
                <Label
                  for='choices-payment-type'
                  className='form-label  text-uppercase fw-semibold'
                >
                  Input Document
                </Label>
                <p className='text-muted mb-2 fs-12 '>
                  Bisa jadi Kalimat tambahan untuk membantu section mengenai apa
                  ini
                </p>
              </div>
            </Col>

            <Row>
              <Col md={3}>
                <div className='mb-2'>
                  <Label htmlFor='invoicingQuantityId' className='form-label '>
                    Nomor Nota Dinas Permintaan (P-Office)
                  </Label>
                  <Input
                    type='text'
                    className='form-control '
                    id='noNotaDinas'
                    name='noNotaDinas'
                    value={form.noNotaDinas || ''}
                    placeholder='Number Generated by P-Office'
                    onChange={e => {
                      handleFormTextChange(e);
                    }}
                    disabled={form.hpsStatusCompleted ? true : false}
                  />
                </div>
              </Col>

              <Col md={6}>
                <p className=' mb-2 fs-12 '>
                  Select Category and Documents to upload
                </p>
                <div className='d-flex overflow-x-auto'>
                  <table className='table table-hover table-centered align-middle table-nowrap mb-2'>
                    <thead className='text-muted table-light'>
                      <tr>
                        <th scope='col' width='80%'>
                          Category FIle
                        </th>
                        <th scope='col' width='20%'>
                          {''}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {!docsLoaded ? (
                        <SkeletonTable inline rows={2} columns={2} />
                      ) : uploadDocument?.items?.length > 0 ? (
                        uploadDocument.items.map((data, index) => (
                          <tr key={`${data.id}-${index}`}>
                            <td>
                              <p className='mb-2 mt-2'>{data.documentName}</p>
                            </td>
                            <td>
                              <ul className='list-inline hstack gap-2 mb-0'>
                                <ActionButton
                                  variant='tertiary'
                                  size='sm'
                                  icon='ri-eye-line'
                                  onClick={() =>
                                    handleDirectOpenNewTab(data.actualUrl)
                                  }
                                >
                                  View
                                </ActionButton>
                                {readonly && (
                                  <ActionButton
                                    variant='destructive'
                                    size='sm'
                                    icon='ri-delete-bin-line'
                                    confirm={false}
                                    onClick={() =>
                                      handleConfirmDelFileUpload(
                                        data.id,
                                        data.documentName
                                      )
                                    }
                                  >
                                    Delete
                                  </ActionButton>
                                )}
                              </ul>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan='3' className='text-center text-muted'>
                            No documents available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>
              {form.hpsStatusCompleted === false && (
                <Col md={3}>
                  <FileUploadSection
                    ids={ids}
                    fetchDocumentUpload={() => fetchDocumentUpload(ids)}
                    formFileUpload={formFileUpload}
                    setFormFileUpload={setFormFileUpload}
                    uploadDocument={uploadDocument}
                    readonly={readonly}
                  />
                </Col>
              )}
            </Row>
          </Row>
        </div>

        <div className='mt-3'>
          <Row>
            <Col sm={12}>
              <div
                style={{
                  borderTopColor: '#b0b8b2',
                  borderTopWidth: '1px',
                  borderTopStyle: 'solid',
                }}
              ></div>
              <div className='flex-grow-1'>
                <Label
                  for='choices-payment-type'
                  className='form-label  text-uppercase fw-semibold'
                >
                  Parcel
                </Label>

                <p className='text-muted mb-2 fs-12 '>
                  Bisa jadi Kalimat tambahan untuk membantu section mengenai apa
                  ini
                </p>
              </div>
            </Col>

            <Col xl={12}>
              <div className='mb-1'>
                {isLoading ? (
                  <SkeletonCard lines={4} />
                ) : error ? (
                  <Col lg={12} className='text-center'>
                    <div className='text-center'>
                      <div className='alert alert-danger' role='alert'>
                        {error}
                      </div>
                    </div>
                  </Col>
                ) : (
                  <>
                    {qtyDeliveryData.items.length > 0 ? (
                      qtyDeliveryData.items.map((data, index) => (
                        <Col sm={12} key={`${data.id}-${index}`}>
                          <Col xxl={12}>
                            <TabPane tabId={`${data.id}2`} id='product'>
                              <Col sm={12}>
                                <Row>
                                  <Col md={5}>
                                    <Row>
                                      <Col sm={6}>
                                        <div className='mb-2'>
                                          <Label
                                            for='product-name-1'
                                            className='form-label fw-semibold'
                                          >
                                            Delivery Unit
                                          </Label>
                                          <Input
                                            type='text'
                                            className='form-control bg-light border-1'
                                            id='deliveryUnitRO'
                                            readOnly
                                            value={data.deliveryUnit || ''}
                                          />
                                        </div>
                                      </Col>

                                      <Col sm={6}>
                                        <div className='mb-2'>
                                          <Label
                                            for='product-name-2'
                                            className='form-label '
                                          >
                                            Pricing Period
                                          </Label>
                                          <Input
                                            type='text'
                                            className='form-control bg-light border-1'
                                            id='deliveryUnitRO'
                                            value={
                                              PricingPeriodData[0].options.find(
                                                option =>
                                                  option.value ===
                                                  data.pricingPeriod
                                              )?.label || ''
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </Col>

                                      <Col sm={6}>
                                        <div className='mb-2'>
                                          <Label
                                            for='product-name-3'
                                            className='form-label '
                                          >
                                            Index Price Reference
                                          </Label>
                                          <Input
                                            type='text'
                                            className='form-control bg-light border-1 '
                                            id='indexPricenameRO'
                                            readOnly
                                            value={data.indexPricename || ''}
                                          />
                                        </div>
                                      </Col>

                                      <Col sm={6}>
                                        <div className='mb-2'>
                                          <Label
                                            for='product-name-3'
                                            className='form-label '
                                          >
                                            Other Index Price
                                          </Label>
                                          <Input
                                            type='text'
                                            className='form-control bg-light border-1 '
                                            id='otherIndexPricenameRO'
                                            readOnly
                                            value={
                                              data.otherIndexPricename || ''
                                            }
                                          />
                                        </div>
                                      </Col>
                                      {data.isCorrelationBetweenTwoIndex && (
                                        <Col sm={12}>
                                          <div className='mb-2'>
                                            <Label
                                              className='form-check-label'
                                              for='inlineCheckbox8'
                                            >
                                              (whichever is lower)
                                            </Label>
                                          </div>
                                        </Col>
                                      )}
                                      {data.pricingPeriod === 1 && (
                                        <Col sm={4}>
                                          <div className='mb-2'>
                                            <Label
                                              for='product-name-3'
                                              className='form-label '
                                            >
                                              Publish Index Period :
                                            </Label>
                                            <Input
                                              type='text'
                                              className='form-control bg-light border-1'
                                              id='startDatePublishIndexRO'
                                              readOnly
                                              value={formatDateToDDMMYYYY(
                                                data.startDatePublishIndex
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      )}
                                      {data.pricingPeriod === 1 && (
                                        <Col sm={4}>
                                          <div className='mb-2'>
                                            <Label
                                              for='product-name-3'
                                              className='form-label '
                                            ></Label>
                                            <Input
                                              type='text'
                                              className='form-control bg-light border-1  '
                                              id='endDatePublishIndex'
                                              readOnly
                                              value={formatDateToDDMMYYYY(
                                                data.endDatePublishIndex
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      )}
                                      {data.pricingPeriod === 2 && (
                                        <Col sm={4}>
                                          <div className='mb-2'>
                                            <Label
                                              for='product-name-3'
                                              className='form-label '
                                            >
                                              Schema B/L Date
                                            </Label>
                                            <Input
                                              type='text'
                                              className='form-control bg-light border-1 '
                                              id='totalamountInput'
                                              readOnly
                                              value={data.schemaBL || ''}
                                            />
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  </Col>

                                  <Col md={7}>
                                    <Label
                                      for='product-name-3'
                                      className='form-label '
                                    >
                                      Information for Pricing
                                    </Label>
                                    <div className='snow-editor '>
                                      <EditorProvider>
                                        <Editor
                                          id='notesForPricingRO'
                                          name='notesForPricingRO'
                                          className='form-control bg-light border-0'
                                          value={data.notesForPricing || ''}
                                          readOnly
                                          style={{
                                            height: '200px',
                                            overflowY: 'auto',
                                          }}
                                        ></Editor>
                                      </EditorProvider>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>

                              {/* <IncotermTableParcelFragment
                                  incoTermTable={incoTermTable}
                                  dataid={data.id}
                                  token={token}
                                /> */}

                              <ModeDeliveryTableFragment
                                procurementId={form.id}
                                quantityDeliveryTermId={data.id}
                                token={token}
                              />

                              <div
                                className='mt-2 mb-2'
                                style={{
                                  borderTopColor: '#b0b8b2',
                                  borderTopWidth: '1px',
                                  borderTopStyle: 'solid',
                                }}
                              ></div>
                            </TabPane>
                          </Col>
                        </Col>
                      ))
                    ) : (
                      <Col lg={12} className='text-center'>
                        <h5 className='fs-15'>
                          <i className='ri-database-2-line me-2'></i>
                          No data available
                        </h5>
                      </Col>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>

        <div className='hstack flex-wrap gap-2 justify-content-end d-print-none mt-1'>
          {readonly && (
            <ActionButton
              variant='secondary'
              icon='ri-draft-line'
              onClick={() => handleSaveHPSrequest({ ids })}
            >
              Save as Draft
            </ActionButton>
          )}
          {readonly && (
            <ActionButton
              variant='primary'
              icon='ri-database-2-line'
              onClick={() => tog_togFirst()}
            >
              Submit HPS Request
            </ActionButton>
          )}
        </div>
      </Row>

      <Modal
        isOpen={modal_togFirst}
        toggle={() => {
          tog_togFirst();
        }}
        id='firstmodal'
        centered
      >
        <ModalHeader
          toggle={() => {
            setmodal_togFirst(false);
          }}
        ></ModalHeader>
        <ModalBody className='text-center p-3 p-sm-5'>
          <div className='mt-2 pt-2'>
            <Row className='justify-content-center mb-1'>
              <Col lg={12} className='text-center'>
                <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
                <h5>Confirm Final Submission</h5>
                <p className='text-muted pb-1'>
                  Are you sure you want to submit this HPS Request process for
                  final validation? This action cannot be undone
                </p>
              </Col>
            </Row>
            {/*
            <Col lg={12}>
              <div className="mb-2 bor border-top  border-top-dashed "></div>
            </Col> */}

            {/* <h4>Confirm Final Submission</h4>
            <p className="text-muted">
              {" "}
              Are you sure you want to submit this planning & procurement
              process for final validation? This action cannot be undone
            </p> */}
            <ActionButton
              variant='primary'
              onClick={() => {
                tog_togSecond();
                tog_togFirst(false);
              }}
            >
              Yes, Next<i className='ri-arrow-right-line align-middle ms-2'></i>
            </ActionButton>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modal_togSecond}
        toggle={() => {
          setmodal_togSecond();
        }}
        id='secondmodal'
        centered
        style={{ maxWidth: modalWidth }}
        className='custom-modal-width'
      >
        <ModalHeader
          toggle={() => {
            setmodal_togSecond(false);
          }}
        ></ModalHeader>
        <ModalBody>
          <Col sm={12}>
            <Row>
              <Row className='justify-content-center mb-1'>
                <Col lg={12} className='text-center'>
                  <img
                    src={metaMask}
                    alt=''
                    height='65'
                    className='mb-3 pb-2'
                  />
                  <h5>Digital Signature Confirmation</h5>
                </Col>
              </Row>

              <Col lg={12}>
                <div className='mb-2 bor border-top  border-top-dashed '></div>
              </Col>

              <Col sm={12}>
                <div className='mb-2 mt-2'>
                  <Label for='FullName' className='form-label fw-semibold '>
                    Full Name:
                  </Label>
                  <Input
                    type='text'
                    id='FullName'
                    name='FullName'
                    value={user.username}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='Position' className='form-label fw-semibold '>
                    Position:
                  </Label>
                  <Input
                    type='text'
                    id='Position'
                    name='Position'
                    value={user.position}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='Division' className='form-label fw-semibold '>
                    Division:
                  </Label>
                  <Input
                    type='text'
                    id='Division'
                    name='Division'
                    value={user.division}
                    className='form-control'
                    onChange={e => {
                      handleTextChange(e);
                    }}
                    disabled={true}
                  />
                </div>
              </Col>

              <Col sm={12}>
                <div className='mb-2'>
                  <Label for='deliveryUnit' className='form-label fw-semibold '>
                    Signature:
                  </Label>
                </div>
              </Col>
              <Col sm={12}>
                <div style={{ maxWidth: '100%' }}>
                  <SignatureCanvas
                    ref={sigCanvas}
                    penColor='black'
                    canvasProps={{
                      width: Math.min(370, window.innerWidth - 72),
                      height: 200,
                      className: 'sigCanvas',
                      style: { border: '1px solid #5555' },
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </ModalBody>

        <ModalFooter className='text-center '>
          <ActionButton
            variant='secondary'
            icon='ri-close-line'
            onClick={() => {
              setmodal_togSecond(false);
            }}
          >
            Cancel
          </ActionButton>

          <ActionButton
            variant='primary'
            icon='ri-database-2-line'
            onClick={() => handleAddOverviewSubmit({ ids })}
          >
            Confirm & Submit
          </ActionButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default HpsRequestTab;
